export const buttonStyle = {
  margin: '16px 0 10px 0',
};
